import { createFileRoute, notFound } from "@tanstack/react-router";
import { queryOptions } from "@tanstack/react-query";
import { EventDetailPage } from "@/routes/happening.$slug";
import { getImportedEventBySlug } from "@/lib/events/events.functions";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

function eventQueryOptions(slug: string) {
  return queryOptions({
    queryKey: ["imported-event", slug],
    queryFn: async () => await getImportedEventBySlug({ data: { slug } }),
    staleTime: 5 * 60_000,
  });
}

export const Route = createFileRoute("/fi/happening/$slug")({
  loader: async ({ params, context }) => {
    const { event } = await context.queryClient.ensureQueryData(eventQueryOptions(params.slug));
    if (!event) throw notFound();
    return { slug: params.slug, event };
  },
  head: ({ params }) => {
    const url = `https://whatfinland.com/fi/happening/${params.slug}`;
    return {
      meta: [
        { property: "og:url", content: url },
        ...buildLocaleMeta("fi"),
      ],
      links: [
        { rel: "canonical", href: url },
        ...buildHreflangLinks(`/fi/happening/${params.slug}`),
      ],
    };
  },
  component: EventDetailPage,
});
